import { useEffect, useState } from 'react';

import { Button, ButtonProps } from '@netfront/ui-library';

export interface KanziPrintButtonProps extends Pick<ButtonProps, 'variant' | 'size'> {
  filename?: string;
  text?: ButtonProps['text'];
}

export const KanziPrintButton = ({ filename = 'download', variant = 'primary', size = undefined, text = 'Print' }: KanziPrintButtonProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onPrintClick = () => {
    setIsLoading(true);

    if (!window.Kanzi_Manual_Commands?.GeneratePdf) {
      setIsLoading(false);
      return;
    }

    window.Kanzi_Manual_Commands.GeneratePdf(({ preSignedUrl }) => {
      if (!preSignedUrl) {
        setIsLoading(false);
        return;
      }

      fetch(preSignedUrl)
        .then((res) => res.blob())
        .then((blob) => {
          const objectUrl = URL.createObjectURL(blob);
          const downloadLink = document.createElement('a');
          downloadLink.href = objectUrl;
          downloadLink.download = `${filename}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(objectUrl);
        })
        .finally(() => {
          setIsLoading(false);
        });
    });
  };

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) return <></>;
  return(
    <Button
      additionalClassNames='no-kanzi-pdf'
      isLoading={isLoading}
      variant={variant}
      size={size}
      text={text}
      onClick={onPrintClick}
    />
  )
};
